import { toast } from "sonner";
import { Sparkles } from "lucide-react";

export const CHARM_KEY = "lz_charm";

export const readCharm = () => {
  try { return JSON.parse(sessionStorage.getItem(CHARM_KEY) || "null"); } catch { return null; }
};

export const clearCharm = () => sessionStorage.removeItem(CHARM_KEY);

export const useCharm = (charm) => () => {
  if (!charm?.items?.length) return null;
  const text = charm.items[Math.floor(Math.random() * charm.items.length)];
  const picked = { title: charm.title, text };
  sessionStorage.setItem(CHARM_KEY, JSON.stringify(picked));
  window.dispatchEvent(new CustomEvent("lz:charm", { detail: picked }));
  toast.custom(() => (
    <div data-testid="charm-toast"
      className={`w-[340px] max-w-[92vw] rounded-2xl border px-5 py-4 shadow-2xl backdrop-blur-xl ${charm.className}`}>
      <p className="flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.25em] text-amber-200">
        <Sparkles className="w-3.5 h-3.5" /> {charm.title}
      </p>
      <p className="mt-2 font-display text-lg leading-snug text-white" data-testid="charm-toast-text">{text}</p>
      {charm.note && <p className="mt-2 text-xs text-purple-100/80">{charm.note}</p>}
      <p className="mt-1 text-xs text-amber-100/90">Liza will write this on your package.</p>
    </div>
  ), { duration: 8000, className: "!bg-transparent !border-0 !shadow-none" });
  return picked;
};
